import { call, put, takeLatest } from "@redux-saga/core/effects";
import { AdminTableApi } from "./AdminTableApi";
import { AdminTableconstant } from "./AdminTableConstant";

function* getAdmintable({ payload }) {
  try {
    yield put({ type: AdminTableconstant.ADMIN_TABLE_REQUEST });

    const res = yield call(AdminTableApi.getAdminTable, payload);

    yield put({
      type: AdminTableconstant.ADMIN_TABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
  }
}

export function* registerAdmintableSaga() {
  yield takeLatest(AdminTableconstant.ADMIN_TABLE_SAGA, getAdmintable);
}
